/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { ajax } from '@src/common/ajax';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import { AjaxResponse } from '@src/common/ajax/types';
import { SelectOption } from '@src/common/types';
import { LaNodeType, LaNodeTypeResponse } from '../types';

export async function laFetchNodeTypes(): Promise<
  AjaxResponse<LaNodeTypeResponse>
> {
  const {
    payload: { content: rawNodeTypes },
    ...rest
  } = await ajax<{ content: LaNodeType[] }>(
    { content: [] },
    ApiUrl.laNodeTypes,
    { method: 'get' }
  );

  const nodeTypes = sanitize(rawNodeTypes);

  return {
    payload: {
      nodeTypes,
      nodeTypeSelectOptions: nodeTypes.map<SelectOption>(
        ({ name: label, value }) => ({ label, value })
      ),
    },
    ...rest,
  };
}

function sanitize(nodeTypes: LaNodeType[]): LaNodeType[] {
  if (!Array.isArray(nodeTypes)) {
    return [];
  }

  return nodeTypes
    .filter((e) => !!e)
    .map<LaNodeType>((e) => ({
      name: e.name ?? '',
      value: e.value ?? '',
      productCode: e.productCode ?? '',
    }))
    .filter(beUnique);
}

function beUnique(
  item: LaNodeType,
  index: number,
  self: LaNodeType[]
): boolean {
  return index === self.findIndex((t) => t.value === item.value);
}
